export default __webpack_public_path__ + "static/media/one-week-sprint-2.41b0203a.svg";